import { render, staticRenderFns } from "./RouterOutlet.vue?vue&type=template&id=3264d27e&"
import script from "./RouterOutlet.vue?vue&type=script&lang=js&"
export * from "./RouterOutlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports